import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const BlogPostCard = ({ post }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/blog-post-detail?slug=${post?.slug}`);
  };

  return (
    <article
      onClick={handleCardClick}
      className="group overflow-hidden cursor-pointer transition-all duration-250 hover:shadow-glow hover:-translate-y-1"
      style={{ 
        backgroundColor: '#2E2E2C', 
        border: '1px solid #3A3A38', 
        borderRadius: '10px',
        fontFamily: 'IBM Plex Sans, system-ui, sans-serif'
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          handleCardClick();
        }
      }}
    >
      <div className="aspect-[16/9] overflow-hidden" style={{ backgroundColor: '#3A3A38' }}>
        <Image
          src={post?.heroImage}
          alt={post?.heroImageAlt}
          className="w-full h-full object-cover transition-transform duration-250 group-hover:scale-105"
        />
      </div>
      <div style={{ padding: '24px' }}>
        <h2 className="text-lg md:text-lg font-semibold mb-3 line-clamp-2 group-hover:text-primary transition-colors duration-250" style={{ color: '#E8EDDF' }}>
          {post?.title}
        </h2>

        <p className="text-sm md:text-base mb-4 line-clamp-3" style={{ color: '#CFDBD5' }}>
          {post?.excerpt}
        </p>

        <div className="flex items-center justify-between" style={{ paddingTop: '16px', borderTop: '1px solid #3A3A38' }}>
          <div className="flex items-center" style={{ gap: '12px' }}>
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full overflow-hidden flex-shrink-0" style={{ backgroundColor: '#3A3A38' }}>
              <Image
                src={post?.authorAvatar}
                alt={post?.authorAvatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium truncate" style={{ color: '#E8EDDF' }}>
                {post?.author}
              </p>
              <p className="text-xs" style={{ color: '#9CA3AF' }}>
                {format(new Date(post.publishedAt), 'MMM dd, yyyy')}
              </p>
            </div>
          </div>

          <div className="flex items-center group-hover:text-primary transition-colors duration-250 flex-shrink-0" style={{ gap: '8px', color: '#9CA3AF' }}>
            <span className="text-sm hidden sm:inline">Read more</span>
            <Icon name="ArrowRight" size={18} color="currentColor" />
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostCard;